import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { ApiConstants } from '../../shared/constants/api-constants';
import { EmployeesDetailsDto } from './models/employeesDetailsDto';
import { ScopeDetailsWithAvailability } from '../../shared/models/scopes/scope-details-with-availability';
import { SharedConstants } from '../../../app/shared/constants/shared-constants';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private httpClient: HttpClient) { }

  getUserByPuid(puid:string):Observable<any>{
    return this.httpClient.get(ApiConstants.GetUserProfile_Api.replace("{puid}",puid));
  }

  addAttachment(puid:string, attachmentDetails:object):Observable<any>{
    return this.httpClient.post(ApiConstants.UserProfileAddAttachment_Api.replace("{puid}",puid), attachmentDetails);
  }

  removeAttachment(puid:string, attachmentId:string):Observable<any>{
    return this.httpClient.delete(ApiConstants.UserProfileRemoveAttachment_Api.replace("{puid}",puid)+attachmentId);
  }

  getAttachmentsForUser(puid:string):Observable<any>{
    return this.httpClient.get(ApiConstants.GetAttachmentsForUser_Api.replace("{puid}",puid));
  }

  downloadFile(fileId: string)
    : Observable<any> {
    return this.httpClient.get(ApiConstants.Files_Download_Api + `${fileId}`);
  }

  deleteFile(fileId: string): Observable<any> {
    return this.httpClient.delete<any>(
      `${ApiConstants.Files_Delete_Api}${fileId}`
    );
  }

  uploadFile(file: File, foldername: string): Observable<any> {
  const formData = new FormData();
  formData.append(file.name, file);
  return this.httpClient.post(
    ApiConstants.Files_Upload_Api + foldername, formData
  ).pipe(
    catchError((error: HttpErrorResponse) => {
      let errorMessage = SharedConstants.File_Upload_Failed_Error;
      
      if (error.status === 400 && error.error?.errorMessage) {
        // Handle duplicate file error
        errorMessage = error.error.errorMessage;
      } else if (error.status === 401) {
        errorMessage = SharedConstants.UnAuthorized_File_Upload_Error;
      } else if (error.status === 500 && error.error?.errorMessage) {
        errorMessage = error.error.errorMessage;
      }
      
      return throwError(() => errorMessage);
    })
  );
}

  getUserProfileAuthentication() : Observable<any> {
    return this.httpClient.get(ApiConstants.UserProfileAuthorization_Api);
  }

  geteQMSScopesForUserProfile(): Observable<ScopeDetailsWithAvailability[]> {
    return this.httpClient.get<ScopeDetailsWithAvailability[]>(ApiConstants.EQMSScopesLookupForUserProfile_Api);
  }
  getAllUsers(): Observable<any> {
    return this.httpClient.get(ApiConstants.Users_Api);
  }
  getSecurityPermissions(): Observable<any> {
    return this.httpClient.get(ApiConstants.Users_Security_Permission_Api);
  }
  getUserProfileInformationForEdit(puid:any): Observable<any> {
    return this.httpClient.get(ApiConstants.Users_Profile_Data_Api.replace("{puid}",puid));
  }

  updateUserProfile(puid:any,profileInformation:any):Observable<any>{
    return this.httpClient.put(ApiConstants.Update_Profile_Data_Api.replace("{puid}",puid), profileInformation);
  }

  getUsersForMyEmployeesProfile(puid : string) : Observable<EmployeesDetailsDto[]>{
    return this.httpClient.get<EmployeesDetailsDto[]>(ApiConstants.GetUsersForMyEmployeesProfile_Api.replace("{puid}",puid))
  }
}
